function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m362.727 301.991c-5.605-2.321-9.26-7.791-9.26-13.858v-49.907c-68.399-5.874-128.534-53.772-128.534-118.793 0-73.033 72.933-119.433 143.534-119.433 70.625 0 143.533 46.43 143.533 119.433 0 29.905-11.645 58.021-32.789 79.171l-100.138 100.136c-3.949 3.95-10.324 5.747-16.346 3.251z",
  fill: "#fff5f0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m479.211 198.604c21.144-21.15 32.789-49.266 32.789-79.171 0-73.003-72.908-119.433-143.533-119.433v303.136c4.077-.006 7.908-1.697 10.606-4.396z",
  fill: "#f3e4d5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m352.4 512h-64.267c-8.284 0-15-6.716-15-15v-128.533c0-8.284 6.716-15 15-15 43.715 0 79.267 35.552 79.267 79.25v64.283c0 8.284-6.716 15-15 15z",
  fill: "#502b1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m95.333 287.067c-8.284 0-15-6.716-15-15v-64.267c0-8.284 6.716-15 15-15s15 6.716 15 15v64.267c0 8.284-6.715 15-15 15z",
  fill: "#bc8f57"
}), /*#__PURE__*/React.createElement("path", {
  d: "m191.733 447.733h-64.267c-43.708 0-79.267-35.559-79.267-79.267v-64.266c0-25.74 20.797-47.133 47.133-47.133 25.754 0 47.133 20.803 47.133 47.133v49.267h49.267c8.284 0 15 6.716 15 15v64.267c.001 8.284-6.714 14.999-14.999 14.999z",
  fill: "#b45a46"
}), /*#__PURE__*/React.createElement("path", {
  d: "m175.667 222.8h-160.667c-8.284 0-15-6.716-15-15v-192.8c0-8.284 6.716-15 15-15h160.667c8.284 0 15 6.716 15 15v192.8c0 8.284-6.716 15-15 15z",
  fill: "#fff5f0"
}), /*#__PURE__*/React.createElement("circle", {
  clipRule: "evenodd",
  cx: 368.467,
  cy: 159.6,
  fill: "#ff4e00",
  fillRule: "evenodd",
  r: 15
}), /*#__PURE__*/React.createElement("path", {
  d: "m368.467 126.4c-8.284 0-15-6.716-15-15v-32.133c0-8.284 6.716-15 15-15s15 6.716 15 15v32.133c0 8.284-6.716 15-15 15z",
  fill: "#ff4e00"
}), /*#__PURE__*/React.createElement("path", {
  d: "m288.133 512h-96.4c-8.284 0-15-6.716-15-15v-128.533c0-8.284 6.716-15 15-15h96.4c8.284 0 15 6.716 15 15v128.533c0 8.284-6.716 15-15 15z",
  fill: "#64b46e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m239.933 353.467v158.533h48.2c8.284 0 15-6.716 15-15v-128.533c0-8.284-6.716-15-15-15z",
  fill: "#4f8d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 239.933,
  cy: 320.267,
  fill: "#824332",
  rx: 63.2,
  ry: 63.2,
  transform: "matrix(.707 -.707 .707 .707 -156.188 263.462)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m239.933 383.467v-126.4c34.849 0 63.2 28.351 63.2 63.2s-28.351 63.2-63.2 63.2z",
  fill: "#502b1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m175.667 0h-80.334v222.8h80.333c8.284 0 15-6.716 15-15v-192.8c.001-8.284-6.715-15-14.999-15z",
  fill: "#f3e4d5"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#bf3000"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m383.467 159.6c0-8.279-6.72-15-15-15v30c8.28 0 15-6.722 15-15z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m383.467 111.4v-32.133c0-8.284-6.716-15-15-15v62.133c8.284 0 15-6.716 15-15z"
})));

var SvgProtester = function SvgProtester(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProtester, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/protester.1d019545.svg";
export { ForwardRef as ReactComponent };